import * as types from '../mutation-types'
import journalService from '../../services/journals'

const state = {
    loading: false,
    errors: null,
    incomes: [],
    inc_ledgeraccs:[]
}

const actions = {
    getAll({ commit }, data) {
        commit(types.INCOME_LOADING, true)
        journalService.getAll(data).then(
            response => {

                commit(types.LOAD_INCOMES, response.data)
                commit(types.INCOME_LOADING, false)
            },
            error => {
                commit(types.INCOME_FAILURE, error)
                commit(types.INCOME_LOADING, false)
            }
        )
    },
    add({ commit }, data) {
        commit(types.INCOME_LOADING, true)
        commit(types.INCOME_FAILURE, null)
        journalService.add(data).then(
            response => {
                data.id = response.data.id
                data.recorded_by = response.data.recorded_by
                data.ledgeracc = response.data.ledgeracc
                commit(types.ADD_INCOME, data)
                commit(types.INCOME_LOADING, false)
            },
            error => {
                commit(types.INCOME_FAILURE, error)
                commit(types.INCOME_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.INCOME_LOADING, true)
        commit(types.INCOME_FAILURE, null)
        journalService.update(data.journal)
            .then(
                response => {
                    data.journal.ledgeracc = response.data.ledgeracc
                    commit(types.UPDATE_INCOME, data)
                    commit(types.INCOME_LOADING, false)
                },
                error => {
                    commit(types.INCOME_FAILURE, error)
                    commit(types.INCOME_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.INCOME_LOADING, true)
        commit(types.INCOME_FAILURE, null)
        journalService.delete(data.journal.id)
            .then(
                response => {

                    commit(types.DELETE_INCOME, data)
                    commit(types.INCOME_LOADING, false)
                },
                error => {
                    commit(types.INCOME_FAILURE, error)
                    commit(types.INCOME_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_INCOME](state, payload) {
        state.incomes.unshift(payload);
    },
    [types.LOAD_INCOMES](state, payload) {
        state.incomes = payload.incomes
        state.inc_ledgeraccs = payload.ledgeraccs
    },
    [types.UPDATE_INCOME](state, payload) {
      console.log(payload)
        Object.assign(state.incomes[payload.index], payload.journal);
    },
    [types.DELETE_INCOME](state, payload) {
        state.incomes.splice(payload.index, 1)
    },
    [types.INCOME_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.INCOME_LOADING](state, payload) {
        state.loading = payload
    },
}


const getters = {
    INCOMES: state => {
        return state.incomes
    },

    INCOME_LEDGERACCS: state => {
      return state.inc_ledgeraccs
  },


    INCOME_ERROR: state => {
        return state.errors
    },

    INCOME_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/incomes.js